var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"disabled":!_vm.item.id,"icon":"mdi-attachment","label":_vm.$t('integrations.fields.link_to_json'),"hide-label":"","text":""},on:{"click":function($event){return _vm.showLog(_vm.item)}}})}
var staticRenderFns = []

export { render, staticRenderFns }